import React from "react";
import { Descriptions, Button } from "antd";
import DetailedScheduleTour from './DetailedScheduleTour.js';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';
dayjs.extend(advancedFormat);

const DetailedScheduleDayType = (props) => {

  let showEditBySameResource = () => {
    return (props.securityLevels.sameResource == 2 || ((props.resourcesId.resourceId || props.resourcesId.userResourceId) == props.resourcesId.userResourceId));
  }
  const canEdit = props.canEdit === 3 && showEditBySameResource();
  let isApproved = false
  //
  let showEdit = false
  const dayComment = dayjs.unix(props.detailedSchedule.rdtDate).add(props.offset, 'minute');
  const hasTour = props.detailedSchedule.tourId > 0 ? true : false
  if (hasTour) {
    const isTourApproved = props.detailedSchedule.approved == 1 ? true : false
    showEdit = (!isTourApproved) ? true : (props.securityLevels.disableApprovedComments == 3) ? true : false
  } else {
    const today = new Date()
    isApproved = props.detailedSchedule.RDTAllowComment === 0
    today.setHours(0, 0, 0)
    const rdtDate = dayComment.toDate();
    today > rdtDate ? isApproved = true : null
    showEdit = (props.securityLevels.myComment == 3) || !(isApproved)
    console.log(props)
  }
  const showEditDayComment = (canEdit && showEdit && props.securityLevels.updateComment == 3)

  return (
    <React.Fragment>
      <div>
        { // Verificación de edición y permisos
          showEditDayComment &&
          <Button
            type="primary"
            onClick={() => {
              props.openModal(props.detailedSchedule.myRdtComment,
                "myDayComment",
                "Edit My Day Comment",
                props.detailedSchedule.rdtId,
                props.offset);
            }}>Edit My Day Comment</Button>
        }
      </div>
      <Descriptions
        key={props.index} title={'Day Type - ' + (dayComment.format("MM/D/YYYY")) || ""}
        size='small'
        style={{ marginBottom: 30 }}
        bordered>
        <Descriptions.Item label="Name" span={3} >{props.resourceName || ""}</Descriptions.Item>
        <Descriptions.Item label="Date" span={3} >{dayComment.format('dddd, MMMM Do YYYY') || ""}</Descriptions.Item>
        <Descriptions.Item label="Day Type" span={3} >{props.detailedSchedule.dayType || ''}</Descriptions.Item>
        <Descriptions.Item label="Day Type Comment" span={3} >{props.detailedSchedule.rdtComment || ''}</Descriptions.Item>
        {(props.detailedSchedule.showRdtCostObject && props.securityLevels.myScheduleCostObject != 1) && <Descriptions.Item label="Day Type Cost Center" span={3} >{props.detailedSchedule.rdtCostCenter || ''}</Descriptions.Item>}
        {(props.detailedSchedule.showRdtCostObject && props.securityLevels.myScheduleCostObject != 1) && <Descriptions.Item label="Day Type WBS Element" span={3} >{props.detailedSchedule.rdtwsbe || ''}</Descriptions.Item>}
        {props.detailedSchedule.updateComment != 1 && <Descriptions.Item label="My Day Comment" span={3} >{props.detailedSchedule.myRdtComment || ''}</Descriptions.Item>}
      </Descriptions>

      <DetailedScheduleTour
        offset={props.offset}
        detailedSchedule={props.detailedSchedule}
        resourceName={props.resourceName}
        openModal={props.openModal}
        canEdit={canEdit}
        showEdit={showEdit}
        securityLevels={props.securityLevels}
        resourcesId={props.resourcesId}
      />

    </React.Fragment>
  )
}

export default DetailedScheduleDayType;